import { render } from "./AirMouse.vue?vue&type=template&id=4cc94328&scoped=true"
import script from "./AirMouse.vue?vue&type=script&lang=js"
export * from "./AirMouse.vue?vue&type=script&lang=js"

import "./AirMouse.vue?vue&type=style&index=0&id=4cc94328&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc94328"]])

export default __exports__